import { LucideProps } from 'lucide-react'

const Trophy = (props: LucideProps) => (
  <svg
    viewBox="0 0 80 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect
      x="35.0947"
      y="50.5704"
      width="9.34648"
      height="19.5831"
      fill="#E3D9C9"
    />
    <path
      d="M2.5814 8.5H25V45.5C11.1929 45.5 0 34.3071 0 20.5V11.0814C0 9.65573 1.15573 8.5 2.5814 8.5Z"
      fill="#E3D9C9"
    />
    <path
      d="M77.4186 8.5H55V45.5C68.8071 45.5 80 34.3071 80 20.5V11.0814C80 9.65573 78.8443 8.5 77.4186 8.5Z"
      fill="#E3D9C9"
    />
    <path
      d="M64.2788 0.5H15.7041C13.509 0.5 11.7295 2.27948 11.7295 4.47458V29.207C11.7295 44.8157 24.3828 57.469 39.9915 57.469C55.6001 57.469 68.2534 44.8157 68.2534 29.207V4.47458C68.2534 2.27948 66.4739 0.5 64.2788 0.5Z"
      fill="#3363C9"
      stroke="#3363C9"
      strokeWidth="0.44507"
    />
    <rect x="22" y="70.1535" width="35.6056" height="9.34648" fill="#E3D9C9" />
    <path
      d="M39.0794 12.7706C39.4012 11.7802 40.8024 11.7802 41.1242 12.7706L43.7825 20.9519C43.9264 21.3949 44.3392 21.6948 44.8049 21.6948H53.4073C54.4487 21.6948 54.8817 23.0274 54.0392 23.6395L47.0797 28.6958C46.7029 28.9696 46.5452 29.4548 46.6892 29.8977L49.3474 38.0791C49.6693 39.0695 48.5357 39.8931 47.6932 39.281L40.7337 34.2246C40.3569 33.9509 39.8467 33.9509 39.4699 34.2246L32.5105 39.281C31.668 39.8931 30.5344 39.0695 30.8562 38.0791L33.5145 29.8977C33.6584 29.4548 33.5007 28.9696 33.124 28.6958L26.1645 23.6395C25.322 23.0274 25.755 21.6948 26.7964 21.6948H35.3987C35.8645 21.6948 36.2772 21.3949 36.4211 20.9519L39.0794 12.7706Z"
      fill="white"
    />
  </svg>
)

export default Trophy
